import ApiClient from './client'

/** @var ApiClient */
const client = new ApiClient()

export default client
